import { render, staticRenderFns } from "./MembershipFeePolicy.vue?vue&type=template&id=0a461185&scoped=true&"
import script from "./MembershipFeePolicy.vue?vue&type=script&lang=js&"
export * from "./MembershipFeePolicy.vue?vue&type=script&lang=js&"
import style0 from "./MembershipFeePolicy.vue?vue&type=style&index=0&id=0a461185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a461185",
  null
  
)

export default component.exports